function isSafari() {
    var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1
    return is_safari
}

export default isSafari
